import React, { useEffect, useState } from "react";
import { PsychiatricHistorydata } from "../../../AgencyFlow/AgencyScreens/Patientinfoeditscreens/Historydata";
import { FetchPsychiatricHistory } from "../../../../api/helper";

const MentalHealthHistory = () => {
  const [ispsychiatricHistory, setispsychiatricHistory] = useState(false);
  const [psychiatricHistoryData, setPsychiatricHistoryData] = useState({
    psychiatricConditions: {
      anxietyDisorders: false,
      depression: false,
      bipolarDisorder: false,
      schizophrenia: false,
      obsessiveCompulsiveDisorder: false,
      postTraumaticStressDisorder: false,
      substanceUseDisorders: false,
      eatingDisorders: false,
      autismSpectrumDisorder: false,
      adhd: false,
      personalityDisorders: false,
    },
    neurocognitiveDisorders: {
      dementia: false,
      alzheimersDisease: false,
      mildCognitiveImpairment: false,
      parkinsonsDisease: false,
      huntingtonsDisease: false,
    },
    developmentalDisorders: {
      intellectualDisability: false,
      speechLanguageDisorders: false,
      learningDisorders: false,
      touretteSyndrome: false,
    },
    symptoms: {
      suicidalThoughts: false,
      selfHarm: false,
      hearingSeeingThings: false,
      delusions: false,
      anxietyOrPanicAttacks: false,
      moodSwings: false,
      paranoia: false,
      otherSymptoms: false,
      otherSymptomsText: "",
    },
    mentalHealthTreatmentHistory: {
      hospitalizedForPsychiatricCondition: false,
      therapyForMentalHealthConcerns: false,
      prescribedPsychiatricMedications: false,
      historyOfElectroconvulsiveTherapy: false,
      otherTreatmentHistory: false,
      otherTreatmentHistoryText: "",
    },
    substanceUse: {
      alcoholUse: false,
      marijuanaUse: false,
      illicitDrugUse: false,
      intravenousDrugUse: false,
      noSubstanceUse: false,
    },
    familypaychiaticHistory: {
      anxietyDisorders: false,
      depression: false,
      bipolarDisorder: false,
      schizophrenia: false,
      ptsd: false,
      substanceUseDisorders: false,
      otherfamilypaychiaticHistory: false,
      otherfamilypaychiaticHistoryText: "",
    },
    socialEnvironmentalstressors: {
      financialProblems: false,
      rlationshipIssues: false,
      jobRelatedStress: false,
      familyConflicts: false,
      traumaPhysicalEmotionalSexual: false,
      othersocialEnvironmentalstressors: false,
      othersocialEnvironmentalstressorsText: "",
    },
    cognitiveandBehavioralPatterns: {
      difficultyConcentration: false,
      decisionMakingProblems: false,
      problemSolvingChallenges: false,
      impulsiveBehaviors: false,
      othercognitiveandBehavioralPatterns: false,
      othercognitiveandBehavioralPatternsText: "",
    },
    sleepandEnergyLevels: {
      difficultyFallingAsleep: false,
      frequentWaking: false,
      oversleeping: false,
      chronicFatigue: false,
      lowEnergyLevels: false,
    },
  });

  const Getpsychiatrichistory = async () => {
    const agencyId = "680b1432319b16c8ea4c1dbf";
    const patientId = "681b328d561a4d17220aad65";
    try {
      const response = await FetchPsychiatricHistory(agencyId, patientId);
      const data = response?.data?.data;
      if (data && Object.keys(data).length > 0) {
        setPsychiatricHistoryData({
          psychiatricConditions: data.psychiatricConditions || {},
          neurocognitiveDisorders: data.neurocognitiveDisorders || {},
          developmentalDisorders: data.developmentalDisorders || {},
          symptoms: data.symptoms || {},
          mentalHealthTreatmentHistory: data.mentalHealthTreatmentHistory || {},
          substanceUse: data.substanceUse || {},
          familypaychiaticHistory: data.familypaychiaticHistory || {},
          socialEnvironmentalstressors: data.socialEnvironmentalstressors || {},
          cognitiveandBehavioralPatterns: data.cognitiveandBehavioralPatterns || {},
          sleepandEnergyLevels: data.sleepandEnergyLevels || {},
        });
      }
    } catch (error) {
      console.log("Error fetching psychiatric history:", error);
    }
  };

  useEffect(() => {
    Getpsychiatrichistory();
  }, []);

  // ✅ Handle checkbox toggle
  const handleCheckboxChange = (category, key, checked) => {
    setPsychiatricHistoryData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: checked,
      },
    }));
  };

  // ✅ Handle text input for "Other"
  const handleOtherTextChange = (category, key, value) => {
    setPsychiatricHistoryData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [`${key}Text`]: value,
      },
    }));
  };

  // ✅ Collect all fields for summary
  const allFields = Object.values(psychiatricHistoryData).flatMap((section) =>
    Object.entries(section).filter(([key]) => !key.toLowerCase().includes("text"))
  );

  const trueFields = allFields.filter(([_, value]) => value === true);
  const falseFields = allFields.filter(([_, value]) => value === false);

  const displayedFields = [
    ...trueFields.slice(0, 5),
    ...falseFields.slice(0, 5 - trueFields.length),
  ];

  const renderSummary = (key, value) => (
    <div key={key} className="space_between" style={{ marginTop: 19 }}>
      <div className="smoking_txt1">
        {key.replace(/([A-Z])/g, " $1").toUpperCase()}
      </div>
      <div className="smoking_txt1">{value ? "YES" : "NO"}</div>
    </div>
  );

  return (
    <div className="Lifestyle_Determinants_chart1">
      <div className="Lifestyle_Determinants_div1">
        Psychiatric History
        <div onClick={() => setispsychiatricHistory(true)}>
          <img
            src={require("../../../assest/Images/pen_icon.png")}
            alt="Pen Icon"
          />
        </div>
      </div>

      {/* ✅ Summary */}
      {displayedFields.map(([key, value]) => renderSummary(key, value))}

      {ispsychiatricHistory && (
        <div className="modal_history" id="modal">
          <div className="modal-content_history">
            <div className="modal-header_history">
              <div className="modal-title flex items-center text-purple-700 font-semibold text-lg mb-4">
                <span className="material-icons mr-2 text-purple-500">🧠</span>
                Psychiatric History
              </div>
              <button
                className="close-btn_history"
                onClick={() => setispsychiatricHistory(false)}
              >
                &times;
              </button>
            </div>

            <div className="modal-body_history" id="modal-body">
              {PsychiatricHistorydata.map(({ category, label, options }, index) => (
                <div className="category_history" key={index}>
                  <h4>{label}</h4>
                  {Object.entries(options).map(([key, optionLabel], i) => (
                    <div key={i} className="flex flex-col gap-1 mb-2">
                      <label className="flex items-center gap-2">
                        <input
                          type="checkbox"
                          disabled
                          checked={psychiatricHistoryData[category][key] || false}
                          onChange={(e) =>
                            handleCheckboxChange(category, key, e.target.checked)
                          }
                        />
                        {optionLabel}
                      </label>

                      {/* Show text input if "other" checked */}
                      {key.toLowerCase().includes("other") &&
                        psychiatricHistoryData[category][key] && (
                          <input
                            type="text"
                            placeholder="Please specify"
                            className="border p-1 rounded w-full max-w-xs"
                            value={
                              psychiatricHistoryData[category][`${key}Text`] || ""
                            }
                            onChange={(e) =>
                              handleOtherTextChange(category, key, e.target.value)
                            }
                          />
                        )}
                    </div>
                  ))}
                </div>
              ))}
            </div>

            <div className="modal-footer_history">
              <button onClick={() => setispsychiatricHistory(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MentalHealthHistory;
